// Settings can be overridden with environment variables. See webpack.config.js for details.
var sprintf = require('sprintf-js').sprintf;

var Config = {
    analyticsProperty: 'UA-61676869-1',
    contactPhone: '1300 790 337',
    eCryptKey: _ECRYPT_KEY,
    invocationApiUrl: sprintf('%s/api', _INVOCATION_BASE),
    signupAupUrl: _SIGNUP_AUP_URL,
    signupBroadbandTncUrl: _SIGNUP_TNC_BROADBAND,
    signupHostingTncUrl: _SIGNUP_TNC_HOSTING,
    ssoApiUrl: sprintf('%s/api', _SSO_BASE),
    ssoAuthenticationUrl: sprintf('%s/oauth/v2/auth?client_id=%s&response_type=token&redirect_uri=%%s', _SSO_BASE, _SSO_CLIENT_ID),
    ssoLogoutUrl: sprintf('%s/logout', _SSO_BASE),
    ssoProfileUrl: sprintf('%s/profile', _SSO_BASE)
};

module.exports = Config;



// WEBPACK FOOTER //
// ./app/config/Config.js